import { useContext } from 'react';
import AuthContext from '../context/AuthContext';

// Returns auth state and actions from AuthContext.
// Must be used inside an AuthProvider — throws if context is missing.
const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  const { user, isAuthenticated, isLoading, login, logout } = context;

  return { user, isAuthenticated, isLoading, login, logout };
};

export default useAuth;
